export default __webpack_public_path__ + "3b7da250206f509ce8de6cab62de2983.jpeg";